import { c as _c } from "react/compiler-runtime";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { TEAM_AVATAR_BACKGROUND } from "@styles/common-colors";
import { companyMemberSelector } from "@store/members/members-selector";
import { useAppSelector } from "@store/store-helper";
import { getTeamByIdSelector } from "@store/teams/teams-selector";
import { ListItemText, TeamIcon } from "@flat-ui";
import { getPrettyName, getUserInitials } from "@utils/user-utils";
import { UiUtils } from "@stellar/utils";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
/** List item in bulk action dialog for members */
export function MemberListContent(t0) {
  const $ = _c(15);
  const {
    item,
    fallbackLabel
  } = t0;
  let t1;
  if ($[0] !== item.id) {
    t1 = companyMemberSelector(item.id);
    $[0] = item.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const companyMember = useAppSelector(t1);
  let t2;
  if ($[2] !== item.id) {
    t2 = getTeamByIdSelector(item.id);
    $[2] = item.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedTeam = useAppSelector(t2);
  if (!companyMember && !selectedTeam) {
    let t3;
    if ($[4] !== fallbackLabel) {
      t3 = fallbackLabel ? <><SphereAvatar shouldHideWhiteRim={true} initials={getUserInitials({
          email: fallbackLabel
        })} /><ListItemText primary={<var>{fallbackLabel}</var>} /></> : null;
      $[4] = fallbackLabel;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== companyMember) {
    t3 = companyMember && !FaroCoreApiUtils.Member.isTeam(companyMember) ? <SphereAvatar shouldHideWhiteRim={true} src={companyMember.thumbnailUrl} initials={getUserInitials(companyMember)} /> : <SphereAvatar icon={<TeamIcon sx={{
      width: "18px",
      height: "18px"
    }} />} size="small" shouldHideWhiteRim={true} backgroundColor={TEAM_AVATAR_BACKGROUND} />;
    $[6] = companyMember;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== companyMember || $[9] !== selectedTeam?.memberCount || $[10] !== selectedTeam?.name) {
    t4 = companyMember && !FaroCoreApiUtils.Member.isTeam(companyMember) ? <ListItemText primary={FaroCoreApiUtils.Member.isMemberActive(companyMember) ? <var>{getPrettyName(companyMember)}</var> : UiUtils.DASH} secondary={<var>{companyMember.email}</var>} /> : <ListItemText primary={<var>{selectedTeam?.name ?? ""}</var>} secondary={`${selectedTeam?.memberCount ?? 0} members`} />;
    $[8] = companyMember;
    $[9] = selectedTeam?.memberCount;
    $[10] = selectedTeam?.name;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}